import { render, staticRenderFns } from "./ServicosRealizados.vue?vue&type=template&id=3ca8ff0e&scoped=true&"
import script from "./ServicosRealizados.vue?vue&type=script&lang=js&"
export * from "./ServicosRealizados.vue?vue&type=script&lang=js&"
import style0 from "./ServicosRealizados.vue?vue&type=style&index=0&id=3ca8ff0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8ff0e",
  null
  
)

export default component.exports